import R from 'ramda'

const SPEED_THREAD_EXPIRY_DISPLAY_TYPE = 'Speed Thread Expired'
const SPEED_THREAD_EXPIRY_WIDGET_TYPE = 'SPEED_THREAD_EXPIRED'

const isSpeedThreadExpiryDisplayType = R.propEq(
  'type',
  SPEED_THREAD_EXPIRY_DISPLAY_TYPE
)

const convertThreadExpiryToWidget = R.applySpec({
  type: R.always(SPEED_THREAD_EXPIRY_WIDGET_TYPE),
  primary: R.always(true)
})

export { isSpeedThreadExpiryDisplayType, convertThreadExpiryToWidget }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/twitter/form-to-widget/speed-thread-expired.js